// extracted by mini-css-extract-plugin
export default {"wrapper":"breadcrumb_wrapper__B6t2u","separator":"breadcrumb_separator__Laa27","breadcrumb":"breadcrumb_breadcrumb__avAsc","lastItem":"breadcrumb_lastItem__AfM2x"};